import ProjectBreadcrumb from '@/components/project-tables/ProjectBreadcrumb'
import PositionList from './PositionList'

export default function PositionsPage() {
  return (
    <>
      <ProjectBreadcrumb label="Positions" url="../positions" />

      {/* PositionList renders the SettingsPage, because the page's Add
          button and company picker depend on what it loads. */}
      <PositionList />
    </>
  )
}
